/*jshint unused:false*/
/*global fetch */
/*global console */

// Csrf Token
let form_token;
const keepTokenAlive = async function () {
  try {
    const resp = await fetch('/account/token', {
      method: 'GET',
    });
    if (resp.ok) {
      const data = await resp.json();
      if (data.token) {
        document.querySelectorAll('[name="_token"]').forEach(v => {
          v.setAttribute('value', data.token);
        });
        form_token = data.token;
      } else {
        console.log('Token not found in response');
      }
    } else {
      console.log(`Error: ${resp.status} ${resp.statusText}`);
    }
  } catch (error) {
    console.error('Fetch error:', error);
  }
};
document.addEventListener('DOMContentLoaded', (event) => {
  keepTokenAlive(); // Refresh token on page load
  setInterval(keepTokenAlive, 15 * 60 * 1000); // Refresh token every 15 minutes
});
// END Csrf Token


setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
}, 2000);
document.addEventListener("DOMContentLoaded", function() {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});

const searchButton = true;

// Price toggles
let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm = document.getElementById('price-switch');
let selected;
allSwitches.forEach((value) => {
  value.addEventListener('change', (val) => {
    (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
    if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
      (val.target.checked === true) ? selected = 1 : selected = 0;
    }
    toggleSwitches();
    togglePrices();
    updatePrice();
  })
})
let toggleSwitches = () => {
  allSwitches.forEach((v) => {
    (selected === 0) ? v.querySelector('.toggle-personal').checked = true : v.querySelector('.toggle-business').checked = true;
    (selected === 0) ? document.querySelector('#price-toggle-checkbox').checked = false : document.querySelector('#price-toggle-checkbox').checked = true;
  })
  document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
}
let togglePrices = () => {
  priceContainers.forEach((v) => {
    (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
    (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
  })
}
let updatePrice = () => {
  let url = priceSwitchForm.getAttribute('action');
  let formData = new FormData(priceSwitchForm);
  fetch(url, {
    method: 'POST',
    processData: false,
    contentType: false,
    body: formData,
    headers: {
      'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
      'X-Requested-With': 'XMLHttpRequest'
    },
  }).then(
    function(response) {
      if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      response.json().then(function(data) {
        document.querySelector("#price-switch [name=_token]").value = data.token;
      });
    }
  ).catch(function(err) {
    console.log('Fetch Error :-S', err);
  });
}
// End price Toggles

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}

let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed']
});
modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');

  if(hamburger.classList.contains("active")) {
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

// Sticky class for navbar & modal
// window.onscroll = function() {stickyNav()};
// let navbar = document.getElementById('navbar');
// let tingleModal = document.querySelector('.tingle-modal');
// let sticky = navbar.offsetTop;
// function stickyNav() {
//   if (!document.body.classList.contains('tingle-enabled')) {
//     if (window.pageYOffset >= sticky) {
//       navbar.classList.add('is-sticky')
//       tingleModal.classList.add('is-sticky')
//     } else {
//       navbar.classList.remove('is-sticky')
//       tingleModal.classList.remove('is-sticky')
//     }
//   }
// }

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

// Toggle search bar
//   document.getElementById('toggle-search') ? document.getElementById('toggle-search').addEventListener('click', () => {
//     document.querySelector('.header-search').classList.toggle('active');
//     document.querySelector('.search-opener').classList.toggle('active');
//   }) : '';

// Toggle loader when searching
  document.querySelector('.search-button') ? [].slice.call(document.querySelectorAll('.search-button')).forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.remove('loaded')
    })
  }) : '';


// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('.header-content');
if(showMoreButton){
  if (showMoreButton.parentElement.parentElement.querySelectorAll('.header-description > *')) {
    showMoreButton.addEventListener('click', (e) => {
      // console.log('click')
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}
// END Show More


//Dropdown Menu Toggle
const delayTime = 90;
let hideTimeout;

const showMenu = function() {
  const dropdown = this.parentNode.querySelector('div');
  const menuToggle = this;

  const activeClass = document.querySelectorAll(".dropdown-menu .active");
  if (activeClass) {
    activeClass.forEach((item) => {
      item.classList.remove("active", "is-active");
    });
  }

  clearTimeout(hideTimeout);

  dropdown.classList.add("active", "is-active");
  menuToggle.classList.add("active", "is-active");
};

const hideMenu = function() {
  const dropdown = this.parentNode.querySelector('div');
  const menuToggle = this;

  hideTimeout = setTimeout(() => {
    dropdown.classList.remove("active", "is-active");
    menuToggle.classList.remove("active", "is-active");
  }, delayTime);
};

const toggleMenu = function() {
  const dropdown = this.parentNode.querySelector('div');

  if (dropdown.classList.contains("active")) {
    hideMenu.call(this);
  } else {
    showMenu.call(this);
  }
};

const setupEventListeners = () => {
  const menuDropdown = document.querySelectorAll(".dropdown-menu > a");
  const isDesktop = window.innerWidth >= 1281;

  menuDropdown.forEach((menu) => {
    const dropdown = menu.parentNode.querySelector('div');
  
    menu.removeEventListener('click', toggleMenu);
    menu.addEventListener('click', toggleMenu);
  });
};
window.addEventListener('resize', setupEventListeners);
window.addEventListener('DOMContentLoaded', setupEventListeners);

//faqs
// var faqSearch = document.querySelector('.faq-search input');
//
// if(faqSearch !== null){
//   faqSearch.addEventListener('keyup', function(e){
//     var results = document.getElementById('faq-results');
//     if(this.value.length != 0){
//       results.classList.add("active");
//     } else {
//       results.classList.remove("active");
//     }
//   });
// }

//More Options Toggle
// var classname = document.querySelectorAll(".more-options");
//
// var moreOptions = function(e) {
// 	e.preventDefault();
//   var element = document.getElementById("vehicle-search");
//   element.classList.toggle("active");
//   if(element.classList.contains('active')){
//     this.innerHTML = 'Hide additional options';
//   } else {
//     this.innerHTML = 'Show me more options';
//   }
// };
// for (var i = 0; i < classname.length; i++) {
//     classname[i].addEventListener('click', moreOptions, false);
// }

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}

// Contact Form
if(document.getElementById('send-contact-form')){

  document.getElementById('name').addEventListener('input', function() {
    let fullName = this.value.trim();
    let nameParts = fullName.split(' ');

    let forename = nameParts.length > 0 ? nameParts[0] : '';
    let surname = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

    document.getElementById('company').value = fullName;
    document.getElementById('forename').value = forename;
    document.getElementById('surname').value = surname;
  });

  let constraints = {
    full_name: {
      presence: {allowEmpty: false},
      length: {
        minimum: 5,
        message: "must be at least 5 characters"
      },
      format: {
        pattern: /^\S+\s+\S+.*$/,
        message: "must consist of at least two words"
      }
    },
    first_name: {
      presence: {allowEmpty: false},
      length: {
        minimum: 3,
        message: "must be at least 3 characters"
      }
    },
    last_name: {
      presence: {allowEmpty: false},
      length: {
        minimum: 3,
        message: "must be at least 3 characters"
      }
    },
    company: {
      presence: {allowEmpty: false},
      length: {
        minimum: 3,
        message: "must be at least 3 characters"
      }
    },
    email_address: {
      email: {
        message: function(value) {
          return validate.format("^<strong>%{em}</strong> is not a valid email", {
            em: value
          });
        }
      }
    },
    telephone: {
      presence: {allowEmpty: false},
      numericality: {
        message: "must only contain numbers"
      },
      format: {
        pattern: /^(07|7|44|\+44|0[1-3]).*$/,
        message: function(value) {
          return validate.format("^<strong>%{num}</strong> is not a valid telephone number", {
            num: value
          });
        }
      },
      length: {
        minimum: 10,
        maximum: 12
      }
    }
  };
  let availableFields = [];
  document.querySelectorAll('#contact-form [data-validate]').forEach((v)=>{
    availableFields.push(v.dataset.validate);
  })
  let availableConstraints = Object.fromEntries(availableFields.map(col => [col, constraints[col]]));

  document.querySelectorAll('#contact-form [data-validate]').forEach((v)=>{
    if(v && v.value) { setTimeout(() => { v.dispatchEvent(new Event('keyup')) }, 500) }
    v.addEventListener('keyup', (e) => {
      let isValid = validate({
        full_name: (document.querySelector('#name')) ? document.querySelector('#name').value : null,
        first_name: (document.querySelector('#forename')) ? document.querySelector('#forename').value : null,
        last_name: (document.querySelector('#surname')) ? document.querySelector('#surname').value : null,
        company: (document.querySelector('#company')) ? document.querySelector('#company').value : null,
        title: (document.querySelector('#title')) ? document.querySelector('#title').value : null,
        enquiry_type: (document.querySelector('#enquiry-type')) ? document.querySelector('#enquiry-type').value : null,
        email_address: (document.querySelector('#email')) ? document.querySelector('#email').value : null,
        telephone: (document.querySelector('#telephone')) ? document.querySelector('#telephone').value.replace(/\s/g, '') : null,
        address: (document.querySelector('#address')) ? document.querySelector('#address').value : null,
        town: (document.querySelector('#town')) ? document.querySelector('#town').value : null,
        postcode: (document.querySelector('#postcode')) ? document.querySelector('#postcode').value : null,
      }, availableConstraints)

      let field = e.target.dataset.validate;
      if (isValid === undefined) {
        //console.log('all valid')
        document.querySelector('#send-contact-form').disabled = false;
        document.querySelectorAll(`#contact-form [data-validate]`).forEach(v=>{v.classList.remove('invalid')});
        document.querySelectorAll(`#contact-form .validation-error`).forEach(v=>{v.remove()});
      } else {
        document.querySelector('#send-contact-form').disabled = true;
        if (isValid[field] === undefined) {
          //console.log('field valid')
          document.querySelector(`#contact-form [data-validate=${field}]`).classList.remove('invalid');
          document.querySelectorAll(`#contact-form [data-validate=${field}] ~ .validation-error`).forEach(v=>{v.remove()});
        } else {
          //console.log('field invalid')
          document.querySelectorAll(`#contact-form [data-validate=${field}] ~ .validation-error`).forEach(v=>{v.remove()});
          if(e.target.type !== 'checkbox') {
            document.querySelector(`#contact-form [data-validate=${field}]`).classList.add('invalid');
            isValid[field].forEach(v => {
              let error = document.createElement("p");
              error.classList.add('validation-error');
              error.innerHTML = `${v}`;
              document.querySelector(`#contact-form [data-validate=${field}]`).parentElement.appendChild(error);
            })
          }
        }
      }
    })
  })

  let button = document.querySelector('#send-contact-form');

  document.getElementById('send-contact-form').addEventListener("click", function(e) {
    e.preventDefault();

    for (const el of document.getElementById('contact-form').querySelectorAll("[required]")) {
      if (!el.reportValidity()) {
        return alert('Please fill all required fields!');
      }
    }

    document.body.classList.remove('loaded');
    button.disabled = true;
    button.innerHTML = 'Sending...';

    // Do captcha and submit form
    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let form_type = document.getElementById('form_type') ? document.getElementById('form_type').value : 'General Contact';
        let token = document.querySelector('#contact-form [name=_token]').value;
        let deal_type = 'Business - Contract Hire';
        let title = '';
        let forename = '';
        let surname = '';
        let name = '';
        let company = '';
        let email = '';
        let telephone = '';
        let comments = '';
        let address = '';
        let town = '';
        let postcode = '';
        let registration = '';
        let mileage = '';
        let car_id = '';
        let vehicle_type = '';
        let make_model = '';
        let extras = '';
        let purchase_method = '';
        let part_exchange = '';
        let alternative_mailto = false;
        let alternative_mailto2 = false;

        title = document.querySelector('#contact-form [name=title]') ? document.querySelector('#contact-form [name=title]').value : '';
        company = document.querySelector('#contact-form [name=company]') ? document.querySelector('#contact-form [name=company]').value : document.querySelector('#contact-form [name=name]').value;
        forename = document.querySelector('#contact-form [name=forename]') ? document.querySelector('#contact-form [name=forename]').value : '';
        surname = document.querySelector('#contact-form [name=surname]') ? document.querySelector('#contact-form [name=surname]').value : '';
        name = document.querySelector('#contact-form [name=name]') ? document.querySelector('#contact-form [name=name]').value : `${forename} ${surname}`;
        email = document.querySelector('#contact-form [name=email]') ? document.querySelector('#contact-form [name=email]').value : '';
        telephone = document.querySelector('#contact-form [name=telephone]') ? document.querySelector('#contact-form [name=telephone]').value : '';
        comments = document.querySelector('#contact-form [name=comments]') ? document.querySelector('#contact-form [name=comments]').value : '';
        registration = document.querySelector('#contact-form [name=registration]') ? document.querySelector('#contact-form [name=registration]').value : '';
        mileage = document.querySelector('#contact-form [name=mileage]') ? document.querySelector('#contact-form [name=mileage]').value : '';
        make_model = document.querySelector('#contact-form #custom_1') ? document.querySelector('#contact-form #custom_1').value : '';
        extras = document.querySelector('#contact-form #custom_2') ? document.querySelector('#contact-form #custom_2').value : '';
        purchase_method = document.querySelector('#contact-form #custom_3') ? document.querySelector('#contact-form #custom_3').value : '';
        part_exchange = document.querySelector('#contact-form #custom_4') ? document.querySelector('#contact-form #custom_4').value : '';
        alternative_mailto = document.querySelector('#contact-form [name=alternative-mailto]') ? document.querySelector('#contact-form [name=alternative-mailto]').value : false;
        alternative_mailto2 = document.querySelector('#contact-form [name=alternative-mailto2]') ? document.querySelector('#contact-form [name=alternative-mailto2]').value : false;
        // deal_type = document.querySelector('#contact-form [name=deal_type]') ? document.querySelector('#contact-form [name=deal_type]').value : 'Business - Contract Hire';

        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'alternative-mailto': alternative_mailto,
            'alternative-mailto2': alternative_mailto2,
            'deal_type': deal_type,
            'type': form_type,
            'vehicle_type': vehicle_type,
            'car_id': car_id,
            'title': title,
            'name': name,
            'forename': forename,
            'surname': surname,
            'company': company,
            'address': address,
            'town': town,
            'postcode': postcode,
            'email': email,
            'telephone': telephone,
            'comments': `COMMENTS: ${comments} ${registration ? '\n\r ---- REGISTRATION: ' + registration : ''} ${mileage ? '\n\r ---- MILEAGE: ' + mileage : ''} ${make_model ? '\n\r ---- VEHICLE MANUFACTURER & MODEL: ' + make_model : ''} ${extras ? '\n\r ---- VEHICLE EXTRAS: ' + extras : ''} ${purchase_method ? '\n\r ---- PREFERRED METHOD OF PURCHASE: ' + purchase_method : ''} ${part_exchange ? '\n\r ---- PART EXCHANGE: ' + part_exchange : ''}`,
            '_token': token,
            'g-recaptcha-response': recaptcha_token
          }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          button.disabled = false;
          button.innerHTML = 'Send Enquiry';
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status!='ok'){
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            return alert('There was a problem with your form\n\n'+errors);
          }

          document.querySelector('.contact-form') ? document.querySelector('.contact-form').reset() : null;
          document.querySelector('.contact-content') ? document.querySelector('.contact-content').classList.add('hidden') : null;
          document.querySelector('.contact-details-form .thank-you') ? document.querySelector('.contact-details-form .thank-you').classList.remove('hidden') : null;
          document.querySelector('.contact-details-form') ? document.querySelector('.contact-details-form').scrollIntoView() : null;

          // Trigger event tracking form_type
          if (form_type == 'General Contact') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Contact Form Submit'
            });
          } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': form_type + ' Form Submit'
            });
          }


        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });
      });
    });

  });
}

if(document.getElementById('email-signup')){
  let forename = '';
  let surname = '';

  document.getElementById('newsletter-name').addEventListener('input', function() {
    let fullName = this.value.trim();
    let nameParts = fullName.split(' ');

    forename = nameParts.length > 0 ? nameParts[0] : '';
    surname = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

    document.getElementById('newsletter-company').value = fullName;
    document.getElementById('newsletter-forename').value = forename;
    document.getElementById('newsletter-surname').value = surname;
  });

  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    let url = '/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let name = document.getElementById('newsletter-name').value;
    let token = document.getElementsByName('_token')[0].value;
    let deal_type = 'Business - Contract Hire';

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ 'name': name, 'first_name': forename, 'forename': forename, 'company': name, 'surname': surname,'deal_type': deal_type, 'email': email, '_token': token }),
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        return alert('There was a problem with your sign up details\n\n'+$errors);
      }

      document.getElementsByClassName('footer-newsletter-form')[0].reset();
      document.cookie = "newsletter_dismissed=true";

      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Form Submit'
      });
      return alert('Thank you!');

    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  });
}


// SEARCH SIDEBAR
function setUrlParams(param, value, module) {
  let searchUrl = new URL(window.location.origin + window.location.pathname);
  if (module === 'Search') {
    if (window.location.search.includes('offers=specials')) {
      searchUrl.searchParams.set('offers', 'specials');
    } else if (window.location.search.includes('offers=stock')) {
      searchUrl.searchParams.set('offers', 'stock');
    }
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
  } else if (window.location.pathname === '/car-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
  } else if (window.location.pathname === '/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/van-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
  } else if (window.location.pathname === '/van-leasing/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/van-leasing/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/pick-up-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.append('body_type', 'Pick-up');
  } else {
    (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
    (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
    searchUrl.searchParams.set('filter', 'true');
  }
  if(param==='type'){
    searchUrl.searchParams.set('search-type', value);
    searchUrl.searchParams.set('make', '');
    searchUrl.searchParams.set('model', '');
    searchUrl.searchParams.delete('body_type');
  } else {
    searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside input[name="make"]:checked') ? document.querySelector('.search-aside input[name="make"]:checked').value : ''));
    searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside input[name="model"]:checked') ? document.querySelector('.search-aside input[name="model"]:checked').value : ''));
    // param==='make' ? searchUrl.searchParams.set('model', '') : null;

    if(window.location.pathname !== '/pick-up-leasing'){
      searchUrl.searchParams.set('body_type', (param==='body_type') ? value : (document.querySelector('.search-aside input[name="body_type"]:checked') ? document.querySelector('.search-aside input[name="body_type"]:checked').value : ''));
    }

    if(param==='make'){
      searchUrl.searchParams.delete('model');
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='model'){
      searchUrl.searchParams.delete('van_size');
      searchUrl.searchParams.delete('body_type');
    }
  }

  searchUrl.searchParams.set('fuel_type', param==='fuel_type' ? value : (document.querySelector('.search-aside input[name="fuel_type"]:checked') ? document.querySelector('.search-aside input[name="fuel_type"]:checked').value : ''));
  searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside input[name="transmission"]:checked') ? document.querySelector('.search-aside input[name="transmission"]:checked').value : ''));
  searchUrl.searchParams.set('seats', param==='seats' ? value : (document.querySelector('.search-aside input[name="seats"]:checked') ? document.querySelector('.search-aside input[name="seats"]:checked').value : ''));

  searchUrl.searchParams.set('term', param==='term' ? value : (document.querySelector('.search-filters [name="term"]') ? document.querySelector('.search-filters [name="term"]').value : ''));
  searchUrl.searchParams.set('initial_profile', param==='initial_profile' ? value : (document.querySelector('.search-filters [name="initial_profile"]') ? document.querySelector('.search-filters [name="initial_profile"]').value : ''));
  searchUrl.searchParams.set('mileage', param==='mileage' ? value : (document.querySelector('.search-filters [name="mileage"]') ? document.querySelector('.search-filters [name="mileage"]').value : ''));

  searchUrl.searchParams.set('order', param==='order' ? value : (document.querySelector('.search-filters select[name="order"]') ? document.querySelector('.search-filters select[name="order"]').value : ''));

  window.location.href = searchUrl;
}

// Show Only Filters
function updateSearchToggles() {
  let searchToggles = document.querySelectorAll('.search-form .stock input');
  if (searchToggles) {
    if (!searchButton) {
      searchToggles.forEach(value => {
        value.addEventListener('change', (e) => {
          let searchUrl = new URL(window.location.origin + '/car-leasing');
          let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
          (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
          (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Electric') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Hybrid') : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=', 'offers=stock')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('?', '?offers=stock&')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=stock&')) : null;
          (e.target.value === 'stock' && !e.target.checked && window.location.search.includes('offers=stock')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=')) : null;
          window.location.href = searchUrl;
        })
      })
    }
  }
}
// END Show Only Filters

if (searchButton){
  document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
    v.addEventListener('change', e => {
      document.querySelectorAll('#make-wrapper input').forEach(v => { v.checked = false })
      document.querySelector('.search-aside #search-type').value = document.querySelector('.search-aside input[name="search_type"]:checked').value;
      let type = document.querySelector('.search-aside #search-type').value;
      loadManufacturersRadio(type);
    })
  })
}

function loadSearchTriggers() {
  // console.log("loadSearchTriggers");
  if (document.querySelector('.search-aside') && document.querySelector('.search-filters')) {

    let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');

    if (searchButton){
      document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
        v.addEventListener('change', e => {
          selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
          document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
          loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
          let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
          (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        })
      })
    }

    if (document.querySelector('.search-aside #search-type')) {

      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);

        let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
        (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        console.log(".3");
      }

      if(document.querySelector('.search-aside #body_type-wrapper')){
        loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #fuel_type-wrapper')){
        loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #transmission-wrapper')){
        loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
      }

      (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');

      if(!searchButton) {
        document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
          v.addEventListener('change', e => {
            //remove bodytype
            document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
            setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
          v.addEventListener('change', e => {
            //remove van size
            document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
            setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
        //   v.addEventListener('change', e => {
        //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
        //   })
        // })
        document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="seats"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('seats', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        if (document.querySelector('.search-filters select[name="order"]')) {
          document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
            setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        }
      }
      document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
        v.addEventListener('change', e => {
          setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
        v.addEventListener('change', e => {
          setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
        v.addEventListener('change', e => {
          setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })

      if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
        document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      document.querySelectorAll('.button-clear').forEach(v => {
        v.addEventListener('click', e => {
          setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
        })
      })

      // unselectRadio('.search-form input[type=radio]');

    }
  } else {
    if (document.querySelector('#search-bar #search-type')) {
      let selectedMake = document.querySelector('#search-bar [name="make"]').options[document.querySelector('#search-bar [name="make"]').selectedIndex].value;
      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModels(document.querySelector('#search-bar #search-type').value, selectedMake.value);
      }
    }

    // if (document.querySelector('.search-aside') && document.querySelector('.derivative-wrapper')) {
    //   let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //   if (searchButton){
    //     document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //         document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
    //         loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //         let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //         (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       })
    //     })
    //   }
    //
    //   if (document.querySelector('.search-aside #search-type')) {
    //
    //     // Show Models for selected manufacturer
    //     if (selectedMake) {
    //       loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //
    //       let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //       (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       console.log(".3");
    //     }
    //
    //     if(document.querySelector('.search-aside #body_type-wrapper')){
    //       loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #fuel_type-wrapper')){
    //       loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #transmission-wrapper')){
    //       loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //
    //     (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');
    //
    //     if(!searchButton) {
    //       document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
    //           setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           //remove bodytype
    //           document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
    //           setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           //remove van size
    //           document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
    //           setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
    //       //   v.addEventListener('change', e => {
    //       //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
    //       //   })
    //       // })
    //       document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       if (document.querySelector('.search-filters select[name="order"]')) {
    //         document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
    //           setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       }
    //     }
    //     document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
    //       document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
    //       document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
    //       document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     document.querySelectorAll('.button-clear').forEach(v => {
    //       v.addEventListener('click', e => {
    //         setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     // unselectRadio('.search-form input[type=radio]');
    //
    //   }
    // }
  }
}

function unselectRadio(groupSelector) {
  let currentId;
  document.querySelectorAll(groupSelector).forEach((elem) => {
    elem.addEventListener('click', allowUncheck);
    // needed if elem is already pre-checked
    if (elem.checked) {
      currentId = elem.id;
    }
  });

  function allowUncheck(e) {
    if (this.id === currentId) {
      this.checked = false;
      currentId = undefined;
      if (!searchButton) {
        setUrlParams(e.target.dataset.type, e.target.value, document.querySelector('.search-content').dataset.module);
      }
    } else {
      currentId = this.id;
    }
  }
}

//END Search Sidebar

// SEARCH
function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.querySelector('#search-type');
  hiddenField.setAttribute('value', searchType);
  // hiddenField.dispatchEvent(new Event('change'));

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  let slider = document.querySelector('.vehicle-type .slider');
  slider ? slider.classList.toggle("active") : null;

  if (document.querySelector('.search-aside')) {
    setUrlParams('type', searchType, document.querySelector('.search-content').dataset.module);
  } else {
    loadManufacturers(hiddenField.value);
    loadBodyTypes(hiddenField.value);
  }

}

function loadManufacturers($type) {
  if ($type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    let fuel_type = document.querySelector('input[name="fuel_type"]') ? document.querySelector('input[name="fuel_type"]').value : null;
    document.querySelectorAll('select[name="make"]').forEach((v, i) => {
      v.length = 0;
      v.add(loadingOption);
      v.selectedIndex = 0;
      let url = (fuel_type == 'Electric') ? '/api/'+$type+'/manufacturers/ev?available=yes' : '/api/'+$type+'/manufacturers/available';
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        v.length = 0;
        v.add(defaultOption);
        v.selectedIndex = 0;
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]].toLowerCase();
          option.value = keysSorted[x];
          (v.hasAttribute('data-img')) ? option.setAttribute('data-img', `/themes/vanaways/img/manufacturer/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}.svg`) : null;
          (v.hasAttribute('data-url')) ? option.setAttribute('data-url', `/${$type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`) : null;
          v.add(option);
        }

        let dataMakeValue = v.getAttribute('data-manufacturer');
        if (dataMakeValue) {
          v.value = dataMakeValue;
          loadModels(document.querySelector('#search-type').value, dataMakeValue);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    })
  }
}

function loadManufacturersRadio($type) {
  const wrapper = document.querySelector(`#make-wrapper > .accordion-scroll-inner`);
  if (wrapper && $type) {
    let url = '/api/'+$type+'/manufacturers/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let modelWrapper = document.createElement("div");
        modelWrapper.classList.add('model-wrapper');
        modelWrapper.setAttribute('id', `model-wrapper--${value}`);
        modelWrapper.setAttribute('data-make', `${value}`);
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedMake = new URLSearchParams(window.location.search).get('make');
        let selectedType = new URLSearchParams(window.location.search).get('search_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'make');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        ((value == selectedMake) && ($type == selectedType)) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        wrapper.appendChild(modelWrapper);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="make"]') && document.querySelector('.search-aside input[name="make"]:checked')) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="make"]:checked').id.toUpperCase();
      }
      loadSearchTriggers();
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer, $ev_only = false) {
  // console.log('loadModels');
  if ($type && $manufacturer) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    var model_dropdowns = document.getElementsByName("model");
    for (let i = 0; i < model_dropdowns.length; i++) {
      var dropdown = model_dropdowns[i];
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      // Select the option with value equal to data-make
      let dataMake = document.querySelector('.derivative-search-bar select[name="make"]');
      if (dataMake) {
        $manufacturer = dataMake.value;
      }

      if ($manufacturer) {
        dropdown.length = 0;
        dropdown.add(loadingOption);
        dropdown.selectedIndex = 0;

        if(document.querySelector('.derivative-search-bar') && document.querySelector('body').classList.contains('theme-green')){
          $ev_only = true;
        }
        var url = $ev_only ? '/api/'+$type+'/models/'+$manufacturer+'/ev?available' : '/api/'+$type+'/models/'+$manufacturer+'/available';

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          dropdown.length = 0;
          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
          const urlParams = new URLSearchParams(window.location.search);
          const makeParam = urlParams.get('make');
          const modelParam = urlParams.get('model');
          if (modelParam && makeParam == $manufacturer) {
            dropdown.value = modelParam;
          }

          let dataModelValue = dropdown.getAttribute('data-model');
          if (dataModelValue && dataMake) {
            if(dataMake.getAttribute('data-manufacturer') == dataMake.value){
              dropdown.value = dataModelValue;
            } else {
              dropdown.selectedIndex = 0;
            }
          }
        }).catch(function(err) {
          dropdown.length = 0;
          dropdown.add(loadingError);
          dropdown.selectedIndex = 0;
          console.error('Fetch Error -', err);
        });
      }
    }
  }
}

function loadModelsRadio($type, $manufacturer) {
  const wrapper = document.querySelector(`#model-wrapper--${$manufacturer}`);
  if (wrapper && $type && $manufacturer) {

    let url = '/api/'+$type+'/models/'+$manufacturer+'/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedModel = new URLSearchParams(window.location.search).get('model');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'model');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedModel) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').id.toUpperCase();
      }
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypes($type) {
  let dropdown = document.querySelector('[name=body_type]');
  if (dropdown && $type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Bodytype';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/' + $type + '/types?available';
    url += document.querySelector('.search-form [name="make"]').value != '' ? '&make=' + document.querySelector('.search-form [name="make"]').value : '';
    if (document.querySelector('.search-form [name="model"]')) {
      url += document.querySelector('.search-form [name="model"]').value!='' ? '&model='+document.querySelector('.search-form [name="model"]').value : '';
    }

    if (document.querySelector('form.search-form')) {
      if (window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')) {
        url += '&specials=true';
      }
      if (window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')) {
        url += '&stock=true';
      }
    }


    fetch(url).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function (data) {

      dropdown.length = 0;

      var defaultOption = document.createElement('option');
      defaultOption.text = 'Any Bodytype';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      let keysSorted = Object.keys(data).sort(function (a, b) {
        return data[a].localeCompare(data[b])
      });

      const urlParams = new URLSearchParams(window.location.search);
      const body_type = urlParams.get('body_type');

      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
      if (body_type) {
        dropdown.value = body_type;
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypesRadio($type) {
  const wrapper = document.querySelector('#body_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadBodyTypesCheckbox')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedBodyType = new URLSearchParams(window.location.search).get('body_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'body_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedBodyType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
        spanName.innerText = text.replaceAll('4x4', '4x4/SUV');
        spanName.innerText = text.replaceAll('Sports', 'Convertible');
      }

      if (!searchButton) {
        if (document.querySelectorAll('.search-aside input[name="body_type"]')) {
          document.querySelectorAll('.search-aside input[name="body_type"]').forEach(v => {
            v.addEventListener('change', e => {
              setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('body_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadFuelTypesRadio($type) {
  const wrapper = document.querySelector('#fuel_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/fuel-types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
      (window.location.pathname === '/electric-leasing' || window.location.pathname === '/van-leasing/electric' || window.location.pathname === '/hybrid-leasing' || window.location.pathname === '/van-leasing/hybrid') ? wrapper.parentElement.classList.add('visuallyhidden') : wrapper.parentElement.classList.remove('visuallyhidden')
    }

    // console.log('loadFuelTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      delete data['B'];
      delete data['R'];
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]].replace(" ","-");
        let value = (keysSorted[x]=='Any') ? '' : keysSorted[x].replace(" ","-");
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedFuelType = new URLSearchParams(window.location.search).get('fuel_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'fuel_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (selectedFuelType == value) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = (keysSorted[x]=='Any') ? 'Any' : text.replace("-"," ");
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="fuel_type"]')){
          document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
            v.addEventListener('change', e => {
              setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('fuel_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadTransmissionTypesRadio($type) {
  const wrapper = document.querySelector('#transmission-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/transmissions?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadTransmissionTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      // keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]];
        let value = keysSorted[x];
        value = (value === 'Automatic') ? 'A' : (value === 'Manual') ? 'M' : (value === 'Any') ? '' : value;
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedTransmissionType = new URLSearchParams(window.location.search).get('transmission');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'transmission');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedTransmissionType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="transmission"]')){
          document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
            v.addEventListener('change', e => {
              setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

// END SEARCH


document.addEventListener('DOMContentLoaded', () => {

  // Deal Box Slider
  const dealBoxSlider = [].slice.call(document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-ctr'))
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      let sliderID = e.parentElement.parentElement.getAttribute('id')
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.offers-strip#'+sliderID+' .glider-prev',
          next: '.offers-strip#'+sliderID+' .glider-next'
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      })
    })
  }

  // Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount ) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function() {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

  // Google Reviews Slider
  const reviewsSlider = document.querySelector('.reviews-wrapper');
  if (reviewsSlider) {
    const glider = new Glider(reviewsSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      scrollLock: true,
      rewind: true,
      draggable: true,
      arrows: {
        prev: '.reviews .glider-prev',
        next: '.reviews .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });
    sliderAuto(glider, 8000);
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 2,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    })
  }

  // Hero Slider
  const heroSlider = document.querySelector('.hero-offer .full-header-feature');
  if (heroSlider) {
    const gliderHero = new Glider(heroSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.hero-offer .glider-prev',
        next: '.hero-offer .glider-next'
      }
    });
    sliderAuto(gliderHero, 8000);
  }

  // Block Slider
  const blockSlider = document.querySelector('.block-columns-puff .image-carousel');
  if (blockSlider) {
    const blockSlider1 = new Glider(blockSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      dots: '.block-columns-puff .dots'
    });
    sliderAuto(blockSlider1, 5000);
  }

  // Opening Hours Popup
  document.querySelectorAll('.opening-hours-trigger').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      alertify.alert('Opening Times')
        .setting({
          'title': `Opening Times`,
          'message': `<div class="opening-hours">${value.dataset.content}</div>`,
          'label': 'Close'
        });
    })
  });

// Toggle class for accordions
  function toggleAccordions() {
    let acc = document.getElementsByClassName('mobile-accordion-header');
    for (let i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function(ev) {

        for (let i = 0; i < acc.length; i++) {
          if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
            continue;
          }
          acc[i].parentElement.classList.remove('active');
        }

        if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
          setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
        }
        this.parentElement.classList.toggle("active");

      });
    }
  }
  toggleAccordions();

  // FAQs Filters
  if (document.querySelector('#faq-tags-dropdown')){
    const faqCategory = (cat) => {
      if (cat === 'all') {
        document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
        document.querySelector(`.faq-tags > li > a[data-category=all]`).parentElement.classList.add('active')
        document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.remove('visuallyhidden') })
      } else {
        document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
        document.querySelector(`.faq-tags > li > a[data-category=${cat}]`).parentElement.classList.add('active')
        document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.add('visuallyhidden') })
        document.querySelectorAll(`#faq-list > div[data-category=${cat}]`).forEach(v => { v.classList.remove('visuallyhidden') })
      }
    }
    document.querySelectorAll('.faq-tags > li > a').forEach(v => {
      v.addEventListener('click', e => {
        faqCategory(e.target.dataset.category)
      })
    })
    document.querySelector('#faq-tags-dropdown').addEventListener('change', e => {
      faqCategory(e.target.options[e.target.selectedIndex].value)
    })
  }
  // END FAQs Filters

// Video Section
  let videoSections = document.querySelectorAll('.video-section');
  videoSections.forEach((section) => {
    let sectionId = section.getAttribute('data-id');
    let videoButton = document.querySelector(`#video-trigger-${sectionId}`);
    let videoWrapper = document.querySelector(`#video-vid-${sectionId}`);
    let imgWrapper = document.querySelector(`#video-img-${sectionId}`);
    let videoPopup = section.getAttribute('data-video');
    let hasPopup = section.hasAttribute('data-popup');

    if (videoButton && videoWrapper && imgWrapper) {
      videoButton.addEventListener("click", function(e) {
        if (hasPopup && videoPopup) {
          let videoModal = new tingle.modal({
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: "Close",
            cssClass: ['video-modal'],
            onClose: function() {
              this.setContent('');
            }
          });
          videoModal.setContent(`
          <div class="iframe-wrapper">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/${videoPopup}?autoplay=1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>`);
          videoModal.open();
        } else {
          let source = videoWrapper.querySelector('iframe').getAttribute('src');
          let height = imgWrapper.querySelector('img').clientHeight;
          videoWrapper.querySelector('iframe').setAttribute('src', `${source}?autoplay=1`);
          videoWrapper.style.paddingBottom = `${height}px`;
          imgWrapper.classList.add('visuallyhidden');
          videoWrapper.classList.add('active');
        }
      });
    }
  });
// END Video Section

// FAQ Search
  const faqSearchBtn = document.querySelector('#faq-search-btn');
  if (faqSearchBtn) {
    let closeResultsBtn = document.querySelector('#close-results-btn');
    faqSearchBtn.addEventListener('click', function (e) {
      e.preventDefault();

      let search = document.querySelector('#faq-search');
      let all_data = document.querySelectorAll('#faq-list > div');
      let no_results = document.querySelector('#no-results');
      let result_list = document.querySelector('#search-results');

      if (search.value.trim() !== '') {
        result_list.innerHTML = '';
        no_results.classList.add('visuallyhidden');
        let i = 0;
        all_data.forEach((value) => {
          if (value.textContent.toLowerCase().includes(search.value.toLowerCase())) {
            i++;
            result_list.append(value.cloneNode(true));
          }
        });
        toggleAccordions();

        if (i < 1) {
          result_list.innerHTML = '';
          no_results.classList.remove('visuallyhidden');
        }
        document.querySelector('.search-results').classList.add('active');
      } else {
        document.querySelector('.search-results').classList.remove('active');
        result_list.innerHTML = '';
        no_results.classList.remove('visuallyhidden');
        toggleAccordions();
      }
    });

    if (closeResultsBtn) {
      closeResultsBtn.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.search-results').classList.remove('active');
        toggleAccordions();
      });
    }
  }
// END FAQs Search

  // Add To Compare - Car
  document.querySelectorAll('button[data-compare][data-type="car"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/car-comparison" },
                'onclose': comparisonCount
              });
          } else {
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">Car comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/car-comparison" },
                'onclose': comparisonCount
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          e.target.classList.remove('active');
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Car Comparison')
            .setting({
              'title': 'Car Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/car-comparison" },
              'onclose': comparisonCount
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Car Comparison')
          .setting({
            'title': 'Car Comparison',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/car-comparison" },
            'onclose': comparisonCount
          });
      }
    })
  })
  // Add To Compare - Van
  document.querySelectorAll('button[data-compare][data-type="van"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list_vans')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list_vans', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Van Comparison')
              .setting({
                'title': 'Van Comparison',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/van-comparison" },
                'onclose': comparisonCount
              });
          } else {
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Van Comparison',
                'message': `
                  <span class="semi-bold">Van comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/vanaways/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/van-comparison" },
                'onclose': comparisonCount
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
          e.target.classList.remove('active');
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Van Comparison')
            .setting({
              'title': 'Van Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/van-comparison" },
              'onclose': comparisonCount
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list_vans', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Van Comparison')
          .setting({
            'title': 'Van Comparison',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/van-comparison" },
            'onclose': comparisonCount
          });
      }
    })
  })
  // Add To Favourites - Car
  document.querySelectorAll('button[data-favourite][data-type="car"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('favourite_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.favourite] === undefined) {
          if (Object.keys(cookie_obj).length < 30) {
            cookie_obj = {...cookie_obj, [e.target.dataset.favourite] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('favourite_list', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.favouriteAdded = 'true';
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to favourites
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          } else {
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">Favourites list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your favourites list add ${e.target.dataset.name} again.</span>
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.favourite];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list');
          e.target.classList.remove('active');
          e.target.dataset.favouriteAdded = 'false';
          document.querySelector('.tools-main>.favourites') ? e.target.closest('.deal-box').remove() : null;
          alertify.confirm('Your Favourites')
            .setting({
              'title': 'Your Favourites',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from favourites`,
              'labels': { ok: 'Go To Favourites', cancel: 'Close' },
              'onok': function(){ window.location.href = "/favourites" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.favourite}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('favourite_list', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.favouriteAdded = 'true';
        alertify.confirm('Your Favourites')
          .setting({
            'title': 'Your Favourites',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to favourites`,
            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
            'onok': function(){ window.location.href = "/favourites" }
          });
      }
    })
  })
  // Add To Favourites - Van
  document.querySelectorAll('button[data-favourite][data-type="van"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('favourite_list_vans')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.favourite] === undefined) {
          if (Object.keys(cookie_obj).length < 30) {
            cookie_obj = {...cookie_obj, [e.target.dataset.favourite] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('favourite_list_vans', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.favouriteAdded = 'true';
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to favourites
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          } else {
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">Favourites list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your favourites list add ${e.target.dataset.name} again.</span>
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.favourite];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list_vans');
          e.target.classList.remove('active');
          e.target.dataset.favouriteAdded = 'false';
          document.querySelector('.tools-main>.favourites') ? e.target.closest('.deal-box').remove() : null;
          alertify.confirm('Your Favourites')
            .setting({
              'title': 'Your Favourites',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from favourites`,
              'labels': { ok: 'Go To Favourites', cancel: 'Close' },
              'onok': function(){ window.location.href = "/favourites" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.favourite}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('favourite_list_vans', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.favouriteAdded = 'true';
        alertify.confirm('Your Favourites')
          .setting({
            'title': 'Your Favourites',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to favourites`,
            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
            'onok': function(){ window.location.href = "/favourites" }
          });
      }
    })
  })
  // Compare Count
  function comparisonCount() {
    let car_count = 0;
    let cookie = Cookies.get('compare_list')
    if (Cookies.get('compare_list')) {
      let cookie_obj = JSON.parse(cookie);
      car_count = Object.keys(cookie_obj).length;
    }
    document.querySelectorAll('.comparison_counter').forEach(v => { v.innerText = car_count });
    let van_count = 0;
    let van_cookie = Cookies.get('compare_list_vans')
    if (Cookies.get('compare_list_vans')) {
      let van_cookie_obj = JSON.parse(van_cookie);
      van_count = Object.keys(van_cookie_obj).length;
    }
    document.querySelectorAll('.comparison_counter_van').forEach(v => { v.innerText = van_count });
  }
  comparisonCount();
  document.querySelectorAll('div[data-car] .reset, .alertify .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })
  let derivativeField = document.querySelector('#car-comparison select[name=calculator-derivative]');
  if (derivativeField) {
    derivativeField.addEventListener('change', (event) => {
      comparisonCount();
    })
  }
  document.querySelectorAll('div[data-car] .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })

  // Share Button
  document.querySelectorAll('button.share-button').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      alertify.alert('Share')
        .setting({
          'title': `Share ${e.target.dataset.car}`,
          'message': `
                <p class="share-button">
                  <a class="share-facebook" href="https://www.facebook.com/sharer/sharer.php?u=${e.target.dataset.url}" title="Share by Facebook" target="_blank">
                      <svg id="_01.facebook" data-name="01.facebook" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <ellipse id="Ellipse_4401" data-name="Ellipse 4401" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(0.524 1.451)" fill="#fff"/>
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Zm3.748,13.388-.245,2.061a.389.389,0,0,1-.389.346h-2.14V21.9a.276.276,0,0,1-.272.278H13.31a.276.276,0,0,1-.272-.28l.012-6.108H11.428a.389.389,0,0,1-.389-.389V13.347a.389.389,0,0,1,.389-.389h1.609v-2a3.213,3.213,0,0,1,3.386-3.567h1.648a.389.389,0,0,1,.389.389V9.517a.389.389,0,0,1-.389.389h-1.01c-1.094.018-1.3.541-1.3,1.323v1.722h2.4a.389.389,0,0,1,.378.436Z" fill="#405a9a"/>
                      </svg>
                      &nbsp;Share by Facebook
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-twitter" href="https://twitter.com/intent/tweet?text=${e.target.dataset.url}" title="Share by Twitter" target="_blank">
                      <svg id="Group_1789" data-name="Group 1789" xmlns="http://www.w3.org/2000/svg" width="29.535" height="29.535" viewBox="0 0 29.535 29.535">
                        <circle id="Ellipse_4400" data-name="Ellipse 4400" cx="13.5" cy="13.5" r="13.5" transform="translate(0.956 1.089)" fill="#fff"/>
                        <path id="Path_609" data-name="Path 609" d="M14.767,0A14.767,14.767,0,1,0,29.535,14.767,14.767,14.767,0,0,0,14.767,0Zm7.355,10.3a6.235,6.235,0,0,1-1.265,1.389.54.54,0,0,0-.194.422v.049a8.856,8.856,0,0,1-.571,3.082,9.026,9.026,0,0,1-1.681,2.817,8.3,8.3,0,0,1-3.643,2.407,9.113,9.113,0,0,1-2.864.445,8.743,8.743,0,0,1-4.39-1.183.253.253,0,0,1-.121-.28.243.243,0,0,1,.237-.183H8a5.889,5.889,0,0,0,3.292-1,3.2,3.2,0,0,1-2.526-2.17.167.167,0,0,1,.194-.216,2.93,2.93,0,0,0,.536.051h.068A3.191,3.191,0,0,1,7.7,12.993a.167.167,0,0,1,.247-.146,2.806,2.806,0,0,0,.727.282,3.191,3.191,0,0,1-.515-3.869.167.167,0,0,1,.274-.021A8.355,8.355,0,0,0,14.169,12.3h.016a.12.12,0,0,0,.117-.13,3.379,3.379,0,0,1,.074-1.166,3.091,3.091,0,0,1,2.079-2.223,3.418,3.418,0,0,1,1.008-.155,3.179,3.179,0,0,1,2.106.795.412.412,0,0,0,.274.1.418.418,0,0,0,.1-.014,5.888,5.888,0,0,0,1.554-.641.165.165,0,0,1,.243.194A3.154,3.154,0,0,1,20.9,10.4a5.709,5.709,0,0,0,1.018-.344.167.167,0,0,1,.2.239Z" fill="#64adf0"/>
                      </svg>
                      &nbsp;Share by Twitter
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-linkedin" href="https://www.linkedin.com/shareArticle?mini=true&url=${e.target.dataset.url}" title="Share by LinkedIn" target="_blank">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
                          <g id="Layer_1-2"><path d="m542.45,1075.59C248.67,1076.4,5.67,837.06,7,537.78,8.31,242,250.29,1.17,549.67,5.11c293.69,3.86,530.16,244.44,527.95,539.4-2.21,294.77-242.66,531.68-535.17,531.08Zm54.06-279.84v-6.2c0-66.8,0-133.6,0-200.41,0-3,.05-6,.11-8.99.42-21.18,9.69-38.17,25.37-51.72,15.66-13.53,34.22-17.08,54.27-13.95,18.91,2.95,32.2,13.53,40.36,30.67,1.64,3.44,2.99,7.05,4.18,10.68,4.25,12.96,5.56,26.38,5.58,39.9.09,64.8.04,129.61.05,194.41,0,1.92.09,3.84.13,5.58h123.27c0-2.31,0-4.28,0-6.25,0-66.3.06-132.61-.05-198.91-.02-11.48-.35-22.99-1.21-34.43-1.56-20.7-6.03-40.83-14.23-59.97-15.77-36.82-42.18-62.19-80.89-73.85-20.33-6.12-41.16-7.67-62.28-5.54-20.74,2.09-40,8.3-57.29,20.16-13.51,9.27-24.32,21.16-33.63,34.53-.96,1.38-1.6,3.12-3.74,4.19v-17.46c0-5.5.01-10.99,0-16.49-.02-5.59-.06-11.18-.09-16.69-12.71-1.03-119.67-.55-123.31.49,1.36,123.36.08,246.72-.25,370.25h123.65Zm-315.51-370.77c0,122.7,0,244.9,0,367.09,0,.99.12,1.98.21,2.96.01.15.16.29.27.41.1.12.24.21.71.62,38.76,0,77.87,0,116.99-.01,1.49,0,2.98-.15,4.46-.24.15,0,.31-.1.43-.21.12-.11.19-.27.36-.53v-370.1h-123.45Zm62.76-179.65c-5.29.54-10.63.75-15.85,1.68-35.41,6.29-54.7,33.52-54.14,64.01.48,26.14,15.67,48.46,40.02,57.9,13.05,5.06,26.54,5.85,40.28,4.35,7.31-.8,14.38-2.68,21.13-5.61,27.68-11.99,42.46-41.06,36.07-70.92-4.61-21.57-16.92-36.9-37.26-45.53-9.62-4.08-19.78-5.67-30.25-5.89Z" fill="#005983"/></g>
                      </svg>
                      &nbsp;Share by LinkedIn
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-whatsapp" href="whatsapp://send?text=I'd like to share a link with you: ${e.target.dataset.url}" data-action="share/whatsapp/share" title="Share by WhatsApp" target="_blank">
                        <svg id="_08.whatsapp" data-name="08.whatsapp" xmlns="http://www.w3.org/2000/svg" width="29.646" height="29.646" viewBox="0 0 29.646 29.646">
                          <ellipse id="Ellipse_4398" data-name="Ellipse 4398" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(1.293 1.52)" fill="#fff"/>
                          <path id="Path_611" data-name="Path 611" d="M56.371,47.966l-.029-.029a5.756,5.756,0,0,0-9.2,6.676l.254.5-.474,2.3v.029L49.2,56.9l.519.257a5.75,5.75,0,0,0,6.651-9.19Zm-.23,6.436a2.4,2.4,0,0,1-1.274,1.11c-.975.236-2.459,0-4.318-1.718l-.023-.021c-1.617-1.51-2.046-2.768-1.95-3.764A2.387,2.387,0,0,1,49.5,48.6a.529.529,0,0,1,.829.2l.6,1.365a.527.527,0,0,1-.064.538l-.3.39a.517.517,0,0,0-.041.575A5.656,5.656,0,0,0,51.547,52.8a5.967,5.967,0,0,0,1.424,1.02.515.515,0,0,0,.564-.119l.349-.353a.53.53,0,0,1,.536-.164l1.424.41a.532.532,0,0,1,.3.8Z" transform="translate(-37.452 -37.239)" fill="#4cd360"/>
                          <path id="Path_612" data-name="Path 612" d="M14.823,0A14.823,14.823,0,1,0,29.646,14.823,14.823,14.823,0,0,0,14.823,0ZM22.17,15a7.355,7.355,0,0,1-10.622,6.348l-3.706.882a.287.287,0,0,1-.3-.117.281.281,0,0,1-.045-.22l.78-3.788a7.353,7.353,0,1,1,13.9-3.1Z" fill="#4cd360"/>
                        </svg>
                      &nbsp;Share by WhatsApp
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-mail" href="mailto:?subject=I'd like to share a link with you&amp;body=${e.target.dataset.url}" title="Share by Email" target="_blank">
                      <svg id="_01.email" data-name="01.email" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Z" fill="#18235b"/>
                        <g id="email_1_" data-name="email (1)" transform="translate(7.73 9.534)">
                          <g id="Group_6951" data-name="Group 6951" transform="translate(0 2.915)">
                            <g id="Group_6950" data-name="Group 6950">
                              <path id="Path_10117" data-name="Path 10117" d="M7.419,151.224a.8.8,0,0,1-.828,0L0,147.2v5.349a2.071,2.071,0,0,0,2.07,2.07h9.887a2.071,2.071,0,0,0,2.07-2.07V147.2Z" transform="translate(0 -147.2)" fill="#fff"/>
                            </g>
                          </g>
                          <g id="Group_6953" data-name="Group 6953" transform="translate(0.066)">
                            <g id="Group_6952" data-name="Group 6952" transform="translate(0 0)">
                              <path id="Path_10118" data-name="Path 10118" d="M13.938,57.088H4.052a2.058,2.058,0,0,0-2,1.623L9,62.95l6.939-4.239A2.058,2.058,0,0,0,13.938,57.088Z" transform="translate(-2.048 -57.088)" fill="#fff"/>
                            </g>
                          </g>
                        </g>
                      </svg>
                      &nbsp;Share by Email
                  </a>
                </p>`,
          'label': 'Close'
        });
    })
  })

  // Charging Speeds
  if (document.querySelector('#charging-speeds')) {
    function isElementVisible(el) {
      let rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };
      if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;
      return (
        el.contains(efp(rect.left,  rect.top))
        ||  el.contains(efp(rect.right, rect.top))
        ||  el.contains(efp(rect.right, rect.bottom))
        ||  el.contains(efp(rect.left,  rect.bottom))
      );
    }
    function scrollAnimTriggerCheck() {
      if (isElementVisible(document.querySelector('#charging-speeds .deal-charging-legend'))) {
        const speedHome = parseInt(document.getElementById('progress_bar_home').getAttribute('data-speed'));
        const speedFast = parseInt(document.getElementById('progress_bar_fast').getAttribute('data-speed'));
        const speedRapid = parseInt(document.getElementById('progress_bar_rapid').getAttribute('data-speed'));
        const speedUltra = parseInt(document.getElementById('progress_bar_ultra').getAttribute('data-speed'));
        const homeWidth = (speedHome / speedHome) * 100;
        document.body.style.setProperty('--position-home', homeWidth);
        const fastWidth = (speedFast / speedHome) * 100;
        document.body.style.setProperty('--position-fast', fastWidth);
        const rapidWidth = (speedRapid / speedHome) * 100;
        document.body.style.setProperty('--position-rapid', rapidWidth);
        const ultraWidth = (speedUltra / speedHome) * 100;
        document.body.style.setProperty('--position-ultra', ultraWidth);

        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }


  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    hamburger.classList.remove('active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
  }, false);

  const showDescription = document.getElementById('show-description');
  if (showDescription) {
    (document.querySelector('.manufacturer-header-description >*:nth-of-type(2)')) ? showDescription.classList.remove('visuallyhidden') : null;
    showDescription.addEventListener('click', (e) => {
      e.target.parentElement.classList.add('full-description');
    })
  }

  const showFullTable = document.getElementById('show-all-rows');
  if (showFullTable) {
    showFullTable.addEventListener('click', (e) => {
      document.querySelector('#model-table .model-table-body').classList.add('model-table-body--full');
      showFullTable.classList.add('visuallyhidden');
    })
  }

  const showFullSpec = document.getElementById('show-all-spec');
  if (showFullSpec) {
    showFullSpec.addEventListener('click', (e) => {
      document.querySelector('.deal-tabs').classList.remove('hidden');
      showFullSpec.classList.add('visuallyhidden');
    })
  }

  // Model Table Sorting
  function sortTable(elem, type) {
    let tableBody = document.querySelector('#model-table .model-table-body');
    let tableRows = Array.from(tableBody.children);
    let sortName;
    let sortDirection;
    if (type === 'default') {
      sortName = 'price';
      sortDirection = 'desc';
      document.querySelector('#sortSelect').selectedIndex = '0';
    } else {
      sortName = (type !== 'dropdown') ? elem.composedPath()[0].dataset.sortname : elem.options[elem.selectedIndex].dataset.sortname;
      sortDirection = (type !== 'dropdown') ? elem.composedPath()[0].dataset.sortdirection : elem.options[elem.selectedIndex].dataset.sortdirection;
    }

    tableRows.forEach(value => {value.classList.remove('no-price')});

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      if (sortName === 'price') {
        return (dir === 'asc') ? b.localeCompare(a, 'en', {numeric: true}) : a.localeCompare(b, 'en', {numeric: true});
      }
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      if (type === 'default') {
        elem.setAttribute('data-sortdirection', 'desc')
      } else {
        (type !== 'dropdown') ? elem.composedPath()[0].setAttribute('data-sortdirection', 'desc') : null;
      }
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      if (type === 'default') {
        elem.setAttribute('data-sortdirection', 'asc')
      } else {
        (type !== 'dropdown') ? elem.composedPath()[0].setAttribute('data-sortdirection', 'asc') : null;
      }
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }
  // Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val, 'buttons')));
  let sortDropdown = document.querySelector('#model-table .model-table-head #sortSelect');
  (sortDropdown) ? sortDropdown.addEventListener('change', (e) => sortTable(e.target, 'dropdown')) : null;
  // END Model Table Sorting


  // Initialize GLightbox
  if(document.querySelector('.glightbox-gallery')){
    const lightbox = GLightbox({
      selector: '.glightbox'
    });

    // Handle "View Full Gallery" thumbnail click
    if(document.querySelector('.gallery-item.view-full')){
      document.querySelector('.gallery-item.view-full').onclick = function() {
        // Programmatically open the lightbox starting from the first image
        lightbox.open();
      }
    }
  }
  if(document.querySelector('.deal-gallery .swiper-container-wrapper')){
    const galleryThumbs = new Swiper(".gallery-thumbs", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      direction: "horizontal",
      spaceBetween: 5,
      slidesPerView: 3,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        481: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        769: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1441: {
          centeredSlides: true,
          slidesPerView: 5,
          spaceBetween: 15,
          direction: "vertical",
        },
      },
    });

    const galleryTop = new Swiper(".gallery-top", {
      direction: "horizontal",
      spaceBetween: 5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });

    galleryTop.on("slideChangeTransitionStart", function () {
      galleryThumbs.slideTo(galleryTop.activeIndex);
    });

    galleryThumbs.on("transitionStart", function () {
      galleryTop.slideTo(galleryThumbs.activeIndex);
    });
  }

  // Video Modal
  if(document.querySelector('a#review_video')) {
    const video_popup = document.querySelector('a#review_video').dataset.video;
    const videoModal = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: ['video-modal'],
      onClose: function() {
        this.setContent('');
      }
    });
    document.querySelector('a#review_video').addEventListener("click", function(e){
      e.preventDefault();
      videoModal.setContent(`
          <div class="iframe-wrapper">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/${video_popup}?autoplay=1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>`);
      videoModal.open();
    })
  }
  // END Video Modal

  // Load Search Form
  function loadSearchForm () {
    // Load Search Form
    if(document.getElementsByClassName('search-form').length>0){
      updateSearchToggles();
      loadSearchTriggers();
      // Search
      let searchType = document.querySelector('#search-type') ? document.querySelector('#search-type').value : 'van';
      if (document.querySelector('#search-bar')) {
        loadManufacturers(searchType);
        loadBodyTypes(searchType);
      } else {
        // loadManufacturersRadio(searchType);
        loadBodyTypesRadio(searchType);
      }
      document.querySelectorAll('.search-form [name=search-type]').forEach(v => { v.addEventListener("change", function(e){
        if (document.querySelector('#search-bar')) {
          loadManufacturers(searchType, e.target.value);
        } else {
          loadManufacturersRadio(searchType, e.target.value);
          loadBodyTypesRadio(searchType, e.target.value);
        }
      })
      });

      document.querySelectorAll('.search-form [name=make]').forEach(v => { v.addEventListener("change", function(e){
        if (document.querySelector('#search-bar')) {
          if (document.querySelector('[name="fuel_type"]')) {
            loadModels(searchType, e.target.value, true);
          } else {
            loadModels(searchType, e.target.value);
          }
        } else {
          loadModelsRadio(searchType, e.target.value);
        }
      })
      });
    }
  }
  loadSearchForm();
  // END Load Search Form

  // Search Sidebar Toggle
  let sidebarToggle = document.querySelector('#search-filters-toggle');
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', (e) => {
      if (!sidebarToggle.parentElement.classList.contains('active')) {
        setTimeout(() => {
          document.querySelector('body').scrollIntoView();
          console.log(document.querySelector('#search-filters-toggle').parentElement.parentElement)
        }, 500);
        // document.querySelector('.search-content').style.minHeight = `${(document.querySelector('.search-results-form').clientHeight) * 2}px`;
      } else {
        e.preventDefault();
        // document.querySelector('.search-content').style.minHeight = `100px`;
      }
      sidebarToggle.parentElement.classList.toggle('active');
      sidebarToggle.blur();
      sidebarToggle.parentElement.focus();
    })
  }
  // END Search Sidebar Toggle

  // Search Mobile Popup
  const filterButton = document.querySelector('.search-filters-mobile .vehicle-filters');
  const termsButton = document.querySelector('.search-filters-mobile .vehicle-terms');
  let searchSidebar = document.querySelector('.search-aside');
  let searchTerms = document.querySelector('.search-filters');
  // const updateMobileResultsBtn = document.querySelector('.update-mobile-results');
  let modelSelected = 0;
  let specSelected = 0;

  if(filterButton && searchSidebar){
    const modalMobileFilters = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchSidebar ? modalMobileFilters.setContent(searchSidebar.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        let searchAside = document.querySelector('.search-content .search-aside');
        searchAside.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        // loadUrlParams();
        // resetSearch()
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        filterButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-aside');
        document.querySelector('.search-content').prepend(searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        // loadUrlParams();
        // resetSearch()
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    filterButton.addEventListener("click", function(e){
      filterButton.parentElement.classList.toggle('is-active');
      if(filterButton.parentElement.classList.contains("is-active")) {
        modalMobileFilters.open();
      } else{
        modalMobileFilters.close();
      }
    })
  }
  if(termsButton && searchTerms){
    const modalMobileTerms = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar-terms'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchTerms ? modalMobileTerms.setContent(searchTerms.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        searchTerms = document.querySelector('.search-filters');
        searchTerms.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        // loadUrlParams();
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
        // resetSearch()
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        termsButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-filters');
        document.querySelector('.deal-list.deal-boxes').insertAdjacentElement('beforebegin', searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        // loadUrlParams();
        // updateMobileResults();
        // resetSearch()
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    termsButton.addEventListener("click", function(e){
      termsButton.parentElement.classList.toggle('is-active');
      if(termsButton.parentElement.classList.contains("is-active")) {
        modalMobileTerms.open();
      } else{
        modalMobileTerms.close();
      }
    })
  }
  // END Search Mobile Popup

});
